import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrandingManagerService } from '@rx-applications/shared/branding/data-access';

@Component({
  selector: 'rx-applications-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  #brandingManager = inject(BrandingManagerService);
  bannerImageClass = computed(() => this.#brandingManager.getBrandAccess().getTheme());
}
